import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateExpiredPasswordParams {
  username: string;
  oldEncryptedPassword: string;
  newEncryptedPassword: string;
  encryptionKeyId: string;
}

export class UpdateExpiredPasswordRequest extends Request<IUpdateExpiredPasswordParams, IResult> {
  constructor(params: IUpdateExpiredPasswordParams) {
    super('updateExpiredPassword', params);
  }
}
